import Menus from "../Menus";

const HelpTopicFirstStep = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Premiers pas', link: '/topics/about/first-step'},
  ]
    
  const multiMenus = [
    {title: null, filter: 'HelpTopicFirstStep'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicFirstStep